import { render, staticRenderFns } from "./RestStatus.vue?vue&type=template&id=b8fb312c&scoped=true&lang=pug&"
import script from "./RestStatus.vue?vue&type=script&lang=ts&"
export * from "./RestStatus.vue?vue&type=script&lang=ts&"
import style0 from "./RestStatus.vue?vue&type=style&index=0&id=b8fb312c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8fb312c",
  null
  
)

export default component.exports